export default __webpack_public_path__ + "static/media/deal2.763266d0.png";